import { graphql } from "react-relay";

export const reset_password = graphql`
  mutation ResetPasswordMutation($input: ResetPasswordInput!) {
    resetPassword(input: $input) {
      success
      errors
    }
  }
`;
